import styled from "styled-components";

const FirstContainer = styled.div`
  position: relative;
`;
export default FirstContainer;
